export const navBarHeight = "70px"
